// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `ion-button {
  color: var(--ion-color-darkgrey);
  font-family: OpenSans-Bold;
}`, "",{"version":3,"sources":["webpack://./src/app/shared/components/logout/logout.component.scss"],"names":[],"mappings":"AAAA;EACE,gCAAA;EACA,0BAAA;AACF","sourcesContent":["ion-button {\n  color: var(--ion-color-darkgrey);\n  font-family: OpenSans-Bold;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
